<div class="invoice" *ngIf="_invoice">
  <div class="invoice-data">
    <div class="name header-item">
      {{ 'projectEstimate.invoice.invoice' | translate }}
      {{ _invoice.invoiceNumber }}
    </div>
    <div class="amount header-item">
      {{ 'projectEstimate.invoice.amount' | translate }}:
      <span class="data"
        >{{ currencySymbol }} {{ _invoice.invoiceAmount | number }}</span
      >
    </div>
    <div class="status">
      <div [ngClass]="_invoice.status.toLowerCase()">
        {{ 'projectEstimate.invoice.status' | translate }}:
        <span>{{ invoiceStatus | translate }}</span>
      </div>
    </div>
    <div
      *ngIf="!_invoice?.isArchived"
      id="{{ 'invoice-kebab' + _invoice._id }}"
      class="kebab-menu"
      [opsActionMenu]="'action-' + _invoice._id"
      [position]="'right'"
      [offset]="{ x: -50, y: -5 }"
      [optionsFactory]="getActionOptions.bind(this)"
      (itemSelected)="onSelectAction($event)"
    >
      <img src="assets/kebab-menu-purple-nofill.svg" />
    </div>

    <div class="invoice-data-item date">
      {{ 'projectEstimate.invoice.invoiceDate' | translate }}:
      <span class="data">{{ _invoice.invoiceDate | date : 'dd.MM.yyyy' }}</span>
    </div>

    <div class="invoice-data-item expected no-icon" [class.editable]="isEditMode" (click)="isEditMode && expectedDateCal.openDatePicker()">
      {{ 'projectEstimate.invoice.paymentExpectedDate' | translate }}:
      <ops-calendar
        #expectedDateCal
        [isDisabled]="!isEditMode"
        label=""
        isHideIcon="true"
        (dateChanged)="onSelectExpectedDate($event)"
        formName="_invoice.paymentExpectedDate"
        [date]="_invoice.paymentExpectedDate"
      ></ops-calendar>
    </div>

    <div
      [id]="'payment-received-date-' + _invoice?._id"
      class="invoice-data-item received"
      [ngClass]="isReceivedDateVisible"
      [class.red-border]="receivedDateRed"
    >
      <span>{{ 'projectEstimate.invoice.lastPaymentDate' | translate }}: </span>
      <span class="data">{{
        _invoice.paymentReceivedDate | date : 'dd.MM.YYYY'
      }}</span>
    </div>
    <div class="invoice-data-item bank-item bank">
      {{ 'projectEstimate.invoice.bank' | translate }}:
      <span class="data">{{ _invoice.bankAccount }}</span>
    </div>
    <div class="invoice-data-item bank-item sent-by">
      <span style="min-width: 50px;">{{ 'projectEstimate.invoice.sentBy' | translate }}:</span>
      <span class="data" [innerHTML]="formatSentBy(_invoice.sentBy)"></span>
    </div>
    <div
      class="invoice-data-item received-amount"
      [ngClass]="isReceivedAmountVisible"
      [class.red-border]="receivedAmountRed"
    >
      {{ 'projectEstimate.invoice.totalReceived' | translate }}:<span
        class="data"
      >
        {{ currencySymbol }} {{ receivedAmount | number : '.0-2' }}
      </span>
    </div>
  </div>

  <div class="payments">
    <span *ngIf="_invoice.payments.length" class="header-item"
      >{{ 'projectEstimate.invoice.payments' | translate }}:</span
    >
    <div
      class="payment"
      *ngFor="let payment of _invoice.payments; let i = index"
    >
      <div class="amount data invoice-data-item">
        <span>{{ 'projectEstimate.invoice.amount' | translate }}:</span>
        <span *ngIf="!isEditMode"
          >{{ currencySymbol }} {{ payment.amount | number : '.0-2' }}</span
        >
        <input
          opsNumber
          *ngIf="isEditMode"
          [value]="payment.amount"
          (input)="onInputAmount($event, payment)"
        />
      </div>

      <div class="invoice-data-item expected expected-payment" (click)="isEditMode && paymentDateCal.openDatePicker()">
        {{ 'projectEstimate.invoice.date' | translate }}:

        <ops-calendar
          #paymentDateCal
          [isDisabled]="!isEditMode"
          invertDirection="'true'"
          label=""
          (dateChanged)="onSelectPaymentDate($event, payment)"
          formName="payment.date"
          [date]="payment.date"
        ></ops-calendar>
      </div>
    </div>
    <div class="payment added" *ngIf="newPayment">
      <div class="amount invoice-data-item">
        {{ 'projectEstimate.invoice.amount' | translate }}:
        <input
          opsNumber
          value="{{ newAmount }}"
          (input)="onInputAmount($event, newPayment)"
        />
      </div>
      <div class="invoice-data-item expected expected-payment" (click)="newPaymentDateCal.openDatePicker()">
        {{ 'projectEstimate.invoice.date' | translate }}:
        <ops-calendar
          #newPaymentDateCal
          label=""
          invertDirection="'true'"
          (dateChanged)="onSelectPaymentDate($event, newPayment)"
          formName="newPayment.date"
          [date]="newPayment.date"
        ></ops-calendar>
      </div>
    </div>
    <div class="buttons" *ngIf="isEditMode || newPayment">
      <div class="cancel btn" (click)="onCancel()">
        {{ 'projectEstimate.invoice.cancel' | translate }}
      </div>
      <div class="save btn" (click)="onSave()">
        {{ 'projectEstimate.invoice.save' | translate }}
      </div>
    </div>
  </div>
</div>
<ops-action-menu
  *ngIf="_invoice"
  [menuId]="'action-' + _invoice._id"
  (itemSelected)="onSelectAction($event)"
></ops-action-menu>
